import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ReportService {

  private reportUrl: string = `${ environment.apiRoot }/report/`;

  constructor(private http: HttpAuth) { }

  public getReportByid(jobId: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (jobId != null) {
      params.append('jobid', String(jobId));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.reportUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putReport(job_id:string, description:string, appliers:any, email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == ''){
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
      }
    }else{
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
        'email' : email,
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.put(this.reportUrl, data,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postReport(job_id:string, description:string, appliers:any, email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == ''){
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
      }
    }else{
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
        'email' : email,
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.post(this.reportUrl, data,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/report.service.ts